import { type DynamicWidgetActionRequest } from '@apps/web/components/phoebe_chat/dynamic_widget_action';

export type ReferenceData = {
    readonly type: string;
    readonly id: string;
    readonly display_name: string;
    readonly metadata?: Record<string, unknown> | null;
};

export type ShiftSuggestion = {
    readonly caregiverId: string;
    readonly caregiverName: string;
    readonly reasoning: string;
};

export type ShiftTab = {
    readonly shiftId: string;
    readonly label: string;
    readonly headerRows: Array<string>;
    readonly suggestions: Array<ShiftSuggestion>;
};

export type AssistantPromptAction = (
    request: string | DynamicWidgetActionRequest,
) => Promise<boolean | void> | boolean | void;

// Single contract for how shift references in an assistant response should
// render their actions, replacing three coupled booleans threaded through the
// chat view -> timeline -> message bubble -> shift cards layers.
export type ShiftActionPolicy = {
    // Outreach has already started for this turn: suppress the shift cards.
    readonly outreachStarted: boolean;
    // Offer the "create outreach" action on referenced shifts.
    readonly showCreateOutreachAction: boolean;
    // Shift ids that are the current outreach target (lower-cased matching).
    readonly currentOutreachShiftIds?: ReadonlyArray<string>;
};

export const DEFAULT_SHIFT_ACTION_POLICY: ShiftActionPolicy = {
    outreachStarted: false,
    showCreateOutreachAction: true,
};
